import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@common/checkbox";
import { Button } from "@common/button";
import { useExportData } from "@planzone/view-models";
import { ExportsDataTypes, ExportsFormats, filter as f } from "@planzone/dto";

import { Props } from "./types";
import { Filters } from "./filters";
import { YearSelector } from "./filters/yearSelector";
import styles from "./styles.scss";

function CustomCpamReport(props: Props) {
  const [filter, setFilter] = React.useState(f);
  const [isChecked, setIsChecked] = useState(false);
  const { t } = useTranslation();
  const { isRequestPending, exportData } = useExportData();
  const [year, setYear] = React.useState<number>(new Date().getFullYear());

  return (
    <div
      className={classNames(styles.cpamReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("exportReportsPage.customCpamReport.title")}
          </h2>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.CUSTOM_CPAM_REPORT,
                  data: {
                    planzone: props.planzone,
                    year: year,
                    filter: filter,
                  },
                },
                format: ExportsFormats.EXCEL,
              });
            }}
          >
            {t("exportReportsPage.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("exportReportsPage.customCpamReport.year")}
            </h3>
            <YearSelector year={year} select={setYear} />
          </div>
          <Filters filter={filter} setFilter={setFilter} />
        </div>
      )}
    </div>
  );
}

export { CustomCpamReport };
